export default __webpack_public_path__ + "static/timr45w-c8dd9702590ff1f81616e1f40979f852.ttf";